"use client";
import dynamic from "next/dynamic";
import { usePathname, useSearchParams } from "next/navigation";
import { useCallback, useEffect, useMemo, useState } from "react";

import useStore from "../../../lib/Store/useStore";
import { getFlagEmoji } from "../../../utils/countryUtils";
import TypographyPoppins from "../../Atoms/TypographyPoppins";
import { getPathSpecificCountryData } from "./constants.js";
import { AUTHENTICATED } from "../../../public/Constants/EnumConstants";
import { fetchGeoLocation } from "../../../lib/User/IP2LocationApi";
import { getAuthSession } from "@/lib/User/action";

const DropDown = dynamic(() => import("./DropDown"));

const CurrencySelectorDropdown = () => {
    const searchParams = useSearchParams();
    const pathName = usePathname();
    const {
        flag,
        country,
        currency,
        userData,
        authStatus,
        countriesRates,
        changeCurrency,
        getCountriesList,
        countryDefaultValue,
        hasCountryHydrated,
        showCountrySelectionPopUp,
    } = useStore();

    const isSaudia = searchParams.get("sa");
    const [value, setValue] = useState(false);
    const [visible, setVisible] = useState(false);

    const pathSpecificCountryData = useMemo(
        () => getPathSpecificCountryData(pathName),
        [pathName]
    );

    // Function to handle keydown events for keyboard accessibility
    const handleKeyDown = (event) => {
        if (event?.key === "Enter" || event?.key === " ") {
            setValue((prev) => !prev);
        } else if (event?.key === "Escape") {
            setValue(false);
        }
    };
    console.log({ countryDefaultValue });
    // Memoize the function that sets the country
    const setCountry = useCallback(async (country_code) => {
        console.log("--- SET COUNTRY ---");
        const filterData = countriesRates?.find(
            (country) => country?.iso_alpha_2 === country_code
        );
        if (!filterData) return;

        const data = {
            country: filterData?.country,
            flag: filterData?.iso_alpha_2,
            currency: filterData?.code,
            price: filterData?.subscription_rate,
            exchangeRate: filterData?.exchangeRate,
        };
        console.log({ data });
        changeCurrency(data);
    }, []);

    // Memoize the function to fetch user location, so it doesn't re-run unnecessarily
    const getUserLocation = useCallback(async () => {
        console.log("-- GET USER LOCATION CALLED --")
        console.log(countryDefaultValue, pathSpecificCountryData?.flag)
        console.log("getUserLocation:: ", { flag: flag, currency: currency, country: country })
        if (countryDefaultValue || !flag || !currency) {
            if (pathSpecificCountryData?.flag) {
                console.log("pathSpecificCountryData exist ");
                setCountry(pathSpecificCountryData?.flag); //set path-specific-flag
            } else {
                // showCountrySelectionPopUp(true);
                console.log("trigger geoip api");
                const result = await fetchGeoLocation(); //fetch location from IP2Location api
                console.log({ result });
                if (result?.country_code) setCountry(result?.country_code);
            }
            setValue(false);
        }
    }, []);

    useEffect(() => {
        const isCheckout = pathName === "/checkout/";
        const step = searchParams.get("step");

        const shouldBeVisible =
            userData?.payment_status !== "paid" &&
            (!isCheckout || step === "address");

        setVisible(shouldBeVisible);
    }, [pathName, searchParams, userData]);

    // Run effect based on certain conditions
    useEffect(() => {
        const setCountryFlag = async () => {
            console.log("setCountryFlag:: ", { flag: flag, currency: currency, country: country })
            const authAession = await getAuthSession();
            if (authAession?.user?.countryCode) {
                setCountry(authAession.user.countryCode);
            } else if (isSaudia) {
                setVisible(true);
                setCountry("SA");
            } else {
                setVisible(true);
                getUserLocation(); // Fetch user location if no flag or pathSpecificCountryData
            }
        };
        if (hasCountryHydrated && (countryDefaultValue || !flag || !currency)) setCountryFlag();
    }, [hasCountryHydrated, flag, currency]);

    return (
        <div className="relative w-[80px]">
            <button
                className=" cursor-pointer flex gap-x-2 items-center text-xs lg:text-sm font-medium h-8 lg:h-10 min-w-fit"
                onClick={() => setValue((prev) => !prev)}
                disabled={!visible}
                onKeyDown={handleKeyDown}
                aria-expanded={value}
                aria-controls="currency-dropdown"
            >
                <div className="flex gap-2 justify-center items-center ">
                    <span
                        className="inline-flex items-center justify-center w-8 h-8 text-xl rounded"
                        aria-label={`Flag of ${pathSpecificCountryData?.country || country}`}
                    >
                        {getFlagEmoji(pathSpecificCountryData?.flag || flag)}
                    </span>

                    <TypographyPoppins
                        size={"sm"}
                        fontWeight={"light"}
                        color={"White"}
                        text={pathSpecificCountryData?.flag || flag}
                        customStyle={"!capitalize"}
                    />
                </div>

                {/* {visible && (
                    <Image
                        width={0}
                        height={0}
                        className={ARROW_CLASS + (value ? ARROW_ROTATE : "")}
                        src={DownArrow}
                        alt="Chevron"
                    />
                )} */}
            </button>
            {value && <DropDown setValue={setValue} />}
        </div>
    );
};

export default CurrencySelectorDropdown;
